import React from 'react';
import Selectors from '../hooks/selectors';
import NavigationDropDown from './NavigationDropDown';
import TabLabel from './TabLabel';

const TabsDropDown = () => {
  const { tabs } = Selectors.useTabsDropDown();
  if (tabs.length > 1) {
    return (
      <NavigationDropDown tabs={tabs} />
    );
  }

  return <TabLabel tab={tabs[0]} />;
};

export default TabsDropDown;
